import { createContext, useContext } from 'react';

/**
 * Registry of built-in `AppMenu` entries -- add the new key's `enabled`/
 * `render` pair to `APP_MENU_ITEMS` in `app-menu.tsx` when adding one.
 */
export type AppMenuItemKey =
	| 'downloadedIssues'
	| 'favorites'
	| 'install'
	| 'settings'
	| 'about'
	| 'signOut';

/**
 * Which `AppMenu` entries a *template* supports at all -- set once per
 * template via `TenantAppManifest.appMenu` (`create-tenant-app.tsx`), the
 * same "opt in per template" shape `routes` already uses for catalog
 * routes. Provided by `RootRouteComponent` so every page under that
 * template's router can read it, same channel `sessionTracker` uses.
 *
 * This is structural (compile-time, per template) and deliberately
 * separate from a tenant's own runtime toggle for a given item (e.g.
 * `config.app.downloadedIssues.enabled`) -- mirrors `routes`' own
 * `favorite`/`drafts` filtering in `create-tenant-app.tsx`: a template
 * must both support the entry *and* have the tenant opt into it.
 */
export const AppMenuConfigContext = createContext<Array<AppMenuItemKey>>([]);

export function useAppMenuTemplateItems(): Array<AppMenuItemKey> {
	return useContext(AppMenuConfigContext);
}
